module.exports = __webpack_public_path__ + "assets/img/1-1.6eb1fb36.png";